import { BillingPeriod, FeatureType, ItemType, BillingType } from './pricing.types.js';
import { SubscriptionTier } from '@fabric/woody-client';
import { getCompatEnv } from '@fabric-app/compat/capabilities/environment';

const getPlans = () => {
  const PRICING = getCompatEnv().PRICING;
  return [
    {
      name: SubscriptionTier.FREE,
      title: "Free",
      prices: {
        type: BillingType.Recurring,
        billedMonthly: 0,
        billedYearly: 0
      },
      items: [
        {
          type: ItemType.Feature,
          featureType: FeatureType.Regular,
          has: true,
          description: "250MB storage space"
        },
        {
          type: ItemType.Feature,
          featureType: FeatureType.Regular,
          has: false,
          description: "AI voice notes"
        },
        {
          type: ItemType.Feature,
          featureType: FeatureType.Regular,
          has: false,
          description: "AI assistant"
        },
        {
          type: ItemType.Feature,
          featureType: FeatureType.Regular,
          has: false,
          description: "Data connections"
        },
        {
          type: ItemType.Feature,
          featureType: FeatureType.Regular,
          has: true,
          description: "10MB maximum upload size"
        },
        {
          type: ItemType.Feature,
          featureType: FeatureType.Regular,
          has: true,
          description: "10 spaces"
        },
        {
          type: ItemType.Feature,
          featureType: FeatureType.Regular,
          has: true,
          description: "1000 items"
        },
        {
          type: ItemType.Feature,
          featureType: FeatureType.Regular,
          has: false,
          description: "Get AI Recap emails"
        }
      ]
    },
    {
      name: SubscriptionTier.STARTER,
      title: "Basic",
      prices: {
        type: BillingType.Recurring,
        billedMonthly: 6,
        billedYearly: 5,
        stripePlanIdMonthly: PRICING.BASIC_MONTHLY_PLAN_ID,
        stripePlanIdYearly: PRICING.BASIC_YEARLY_PLAN_ID,
        revenueCatOfferingId: PRICING.BASIC_OFFERING_ID
      },
      items: [
        {
          type: ItemType.Feature,
          featureType: FeatureType.Regular,
          has: true,
          description: "100GB storage space"
        },
        {
          type: ItemType.Feature,
          featureType: FeatureType.Regular,
          has: true,
          description: "AI voice notes"
        },
        {
          type: ItemType.Feature,
          featureType: FeatureType.Regular,
          has: true,
          description: "AI assistant (100 answers)"
        },
        {
          type: ItemType.Feature,
          featureType: FeatureType.Regular,
          has: false,
          description: "Data connections"
        },
        {
          type: ItemType.Feature,
          featureType: FeatureType.Regular,
          has: true,
          description: "No file size limit"
        },
        {
          type: ItemType.Feature,
          featureType: FeatureType.Regular,
          has: true,
          description: "Unlimited spaces"
        },
        {
          type: ItemType.Feature,
          featureType: FeatureType.Regular,
          has: true,
          description: "Unlimited items"
        },
        {
          type: ItemType.Feature,
          featureType: FeatureType.Regular,
          has: true,
          description: "Get AI Recap emails"
        },
        {
          type: ItemType.Feature,
          featureType: FeatureType.Regular,
          has: true,
          description: "Save websites offline (soon)"
        }
      ]
    },
    {
      name: SubscriptionTier.PRO,
      prices: {
        type: BillingType.Recurring,
        billedMonthly: 15,
        billedYearly: 12.5,
        stripePlanIdMonthly: PRICING.PRO_MONTHLY_PLAN_ID,
        stripePlanIdYearly: PRICING.PRO_YEARLY_PLAN_ID,
        revenueCatOfferingId: PRICING.PRO_OFFERING_ID
      },
      title: "Pro",
      items: [
        {
          type: ItemType.Feature,
          featureType: FeatureType.Regular,
          has: true,
          description: "2TB storage space"
        },
        {
          type: ItemType.Feature,
          featureType: FeatureType.Regular,
          has: true,
          description: "AI voice notes"
        },
        {
          type: ItemType.Feature,
          featureType: FeatureType.Regular,
          has: true,
          description: "AI assistant (Unlimited)"
        },
        {
          type: ItemType.Feature,
          featureType: FeatureType.Regular,
          has: true,
          description: "Data connections"
        },
        {
          type: ItemType.Feature,
          featureType: FeatureType.Regular,
          has: true,
          description: "No file size limit"
        },
        {
          type: ItemType.Feature,
          featureType: FeatureType.Regular,
          has: true,
          description: "Unlimited spaces"
        },
        {
          type: ItemType.Feature,
          featureType: FeatureType.Regular,
          has: true,
          description: "Unlimited items"
        },
        {
          type: ItemType.Feature,
          featureType: FeatureType.Regular,
          has: true,
          description: "Get AI Recap emails"
        },
        {
          type: ItemType.Feature,
          featureType: FeatureType.Regular,
          has: true,
          description: "Save websites offline (soon)"
        }
      ]
    },
    {
      name: SubscriptionTier.MAX,
      prices: {
        type: BillingType.Recurring,
        billedMonthly: 39,
        billedYearly: 32.5,
        stripePlanIdMonthly: PRICING.MAX_MONTHLY_PLAN_ID,
        stripePlanIdYearly: PRICING.MAX_YEARLY_PLAN_ID,
        revenueCatOfferingId: PRICING.MAX_OFFERING_ID
      },
      title: "Max",
      items: [
        {
          type: ItemType.Feature,
          featureType: FeatureType.Regular,
          has: true,
          description: "4TB storage space"
        },
        {
          type: ItemType.Feature,
          featureType: FeatureType.Regular,
          has: true,
          description: "AI voice notes"
        },
        {
          type: ItemType.Feature,
          featureType: FeatureType.Regular,
          has: true,
          description: "AI assistant (Unlimited)"
        },
        {
          type: ItemType.Feature,
          featureType: FeatureType.Regular,
          has: true,
          description: "Data connections"
        },
        {
          type: ItemType.Feature,
          featureType: FeatureType.Regular,
          has: true,
          description: "Browser history sync (soon)"
        },
        {
          type: ItemType.Feature,
          featureType: FeatureType.Regular,
          has: true,
          description: "No file size limit"
        },
        {
          type: ItemType.Feature,
          featureType: FeatureType.Regular,
          has: true,
          description: "Unlimited spaces"
        },
        {
          type: ItemType.Feature,
          featureType: FeatureType.Regular,
          has: true,
          description: "Unlimited items"
        },
        {
          type: ItemType.Feature,
          featureType: FeatureType.Regular,
          has: true,
          description: "Get AI Recap emails"
        },
        {
          type: ItemType.Feature,
          featureType: FeatureType.Regular,
          has: true,
          description: "Save websites offline (soon)"
        }
      ]
    }
  ];
};
const getLifetimePlan = () => {
  return {
    name: SubscriptionTier.LIFETIME,
    title: "Believer (Lifetime)",
    prices: {
      type: BillingType.Recurring,
      billedMonthly: 0,
      billedYearly: 0
    },
    items: [
      {
        type: ItemType.Feature,
        featureType: FeatureType.Highlighted,
        has: true,
        description: "Everything in the Pro plan, forever"
      },
      {
        type: ItemType.Separator
      },
      {
        type: ItemType.Feature,
        featureType: FeatureType.Regular,
        has: true,
        description: "Believer badge in profile"
      },
      {
        type: ItemType.Feature,
        featureType: FeatureType.Regular,
        has: true,
        description: "VIP access to the team"
      },
      {
        type: ItemType.Feature,
        featureType: FeatureType.Regular,
        has: true,
        description: "Be a founding member of Fabric"
      }
    ]
  };
};
const getExtensiveLifetimePlan = () => {
  return {
    ...getLifetimePlan(),
    // same as pro plan
    items: [
      ...getPlans().find((plan) => plan.name === "pro").items.map((item) => {
        if (item.type === ItemType.Feature && item.description.includes("AI assistant")) {
          return {
            ...item,
            description: "AI assistant"
          };
        }
        return item;
      }, [])
    ]
  };
};
const planOrderWithDuration = [
  "free",
  `starter-${BillingPeriod.Monthly}`,
  `starter-${BillingPeriod.Yearly}`,
  `pro-${BillingPeriod.Monthly}`,
  `pro-${BillingPeriod.Yearly}`,
  "lifetime",
  `max-${BillingPeriod.Monthly}`,
  `max-${BillingPeriod.Yearly}`
];
const planOrder = [
  "free",
  "starter",
  "pro",
  "lifetime",
  "max"
];
const marketingItems = [
  {
    type: ItemType.Feature,
    featureType: FeatureType.Regular,
    has: true,
    description: "Up to 2TB storage"
  },
  {
    type: ItemType.Feature,
    featureType: FeatureType.Regular,
    has: true,
    description: "No file size limit"
  },
  {
    type: ItemType.Feature,
    featureType: FeatureType.Regular,
    has: true,
    description: "Unlimited spaces"
  },
  {
    type: ItemType.Feature,
    featureType: FeatureType.Regular,
    has: true,
    description: "Unlimited items"
  },
  {
    type: ItemType.Feature,
    featureType: FeatureType.Regular,
    has: true,
    description: "AI assistant"
  },
  {
    type: ItemType.Feature,
    featureType: FeatureType.Regular,
    has: true,
    description: "Get AI Recap emails"
  },
  {
    type: ItemType.Feature,
    featureType: FeatureType.Regular,
    has: true,
    description: "Unlock data connections"
  },
  {
    type: ItemType.Feature,
    featureType: FeatureType.Regular,
    has: true,
    description: "Get new features first"
  },
  {
    type: ItemType.Feature,
    featureType: FeatureType.Regular,
    has: true,
    description: "Be an early supporter ♥️"
  }
];

export { getExtensiveLifetimePlan, getLifetimePlan, getPlans, marketingItems, planOrder, planOrderWithDuration };
//# sourceMappingURL=pricing.config.js.map
